import { gql } from '@apollo/client'

export const GET_ORGS = gql`
  query OrgList($limit: Int, $cursor: Cursor) {
    orgList(limit: $limit, cursor: $cursor) {
      pageInfo {
        endCursor
      }
      orgs {
        id
        displayName
        orgTags
        patientCount
      }
    }
  }
`
